import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { Cell, Grid, Row } from "../../../../_foundation/_grid";
import AdminDataField from "../../../AdminDataField";
import MMTabs from "../../../../mmcomponents/mmtabs/MMTabs";
import ElementSettings from "./ElementSettings";
import ElementDesign from "./ElementDesign";
import Loading from "../../../../_reusables/Loading";
import Box from "../../../../layout/Box";
import ControlIconPicker from "../../controls/ControlIconPicker";
import ControlLink from "../../controls/ControlLink";

const tabs = {
  content: {
    name: "Inhalt",
    icon: "pencil-square-o",
  },
  design: {
    name: "Design",
    icon: "paint-brush",
  },
  settings: {
    name: "Einstellungen",
    icon: "cog",
  },
};

function PopupButton(props) {
  const [element, setElement] = useState(null);
  const [selectedTab, setSelectedTab] = useState("content");

  useEffect(() => {
    setElement(cloneDeep(props.element));
  }, [props.element]);

  useEffect(() => {}, [element]);

  const onEdit = (property, value) => {
    if (props.actions.onEdit) props.actions.onEdit(property, value);
  };

  const actions = {
    onEdit,
  };

  if (!element)
    return (
      <div className="text-center">
        <Loading show={true} />
      </div>
    );

  return (
    <div className="element-popup-heading">
      <div className="admin-tabs">
        <MMTabs
          tabs={tabs}
          selected={selectedTab}
          onUpdate={(selectedKeyName) => setSelectedTab(selectedKeyName)}
        />
      </div>
      {selectedTab === "content" && (
        <TabContent element={element} extra={props.extra} actions={actions} />
      )}
      {selectedTab === "design" && (
        <ElementDesign item={element} itemType="element" actions={actions} />
      )}
      {selectedTab === "settings" && (
        <ElementSettings item={element} actions={actions} />
      )}
    </div>
  );
}

const TabContent = ({ element, extra, actions }) => {
  const iconpositionValues = {
    left: "Links",
    right: "Rechts",
  };

  return (
    <Grid type="full">
      <Row margin="xy">
        <Cell sm={24}>
          <h3>Button</h3>
          <Box size="small">
            <Grid type="full">
              <Row margin="xy">
                <Cell sm={24} md={24}>
                  <AdminDataField
                    value={element.content}
                    editValue={element.content}
                    editType="text"
                    label={"Button Beschriftung"}
                    placeholder={"Gib eine Beschriftung ein..."}
                    editable={true}
                    edit={true}
                    onUpdate={(newValue) => actions.onEdit("content", newValue)}
                  />
                </Cell>
              </Row>
            </Grid>
          </Box>
          <h3>Verlinkung</h3>
          <ControlLink
            item={element}
            extra={extra}
            onUpdate={(property, value) => actions.onEdit(property, value)}
          />
          <h3>Icon</h3>
          <Box size="small">
            <Grid type="full">
              <Row margin="xy">
                <Cell sm={24} md={24}>
                  <ControlIconPicker item={element} onUpdate={actions.onEdit} />
                </Cell>
              </Row>
            </Grid>
          </Box>
          {element.options && element.options.icon && (
            <Box size="small">
              <AdminDataField
                value={element.options.iconposition}
                editValue={element.options.iconposition}
                editType="select"
                selectValues={iconpositionValues}
                label={"Icon Position"}
                editable={true}
                edit={true}
                onUpdate={(newValue) =>
                  actions.onEdit("options.iconposition", newValue)
                }
              />
            </Box>
          )}
        </Cell>
      </Row>
    </Grid>
  );
};

export default PopupButton;
